// See /docs/age-verification.md for usage documentation.
class AgeVerification extends HTMLElement {
  constructor() {
    super();

    this.storageKeyName = 'kbc-theme.age-verified';

    if (this.isAgeVerifiedForB2bCustomer()) {
      this.ageIsVerified = true;
      return;
    }

    this.ageIsVerified = localStorage.getItem(this.storageKeyName);
    // if customer has already acknowledged age, do nothing
    if (this.ageIsVerified) return;
  }

  /**
   * Logged-in B2B customers are treated as age verified.
   * @returns {boolean}
   */
  isAgeVerifiedForB2bCustomer() {
    return (
      this.dataset.storeType === 'b2b' &&
      this.dataset.customerLoggedIn === 'true'
    );
  }

  connectedCallback() {
    this.AgeVerificationModal = this.querySelector(
      '[data-age-verification-dialog]'
    );
    this.customerIsUnderAge = this.querySelector('[data-under-age-dialog]');
    this.ofAgeButton = this.querySelector('[data-of-age-button]');
    this.underAgeButton = this.querySelector('[data-under-age-button]');

    // Based on template, we will show the verification modal.
    // Passed from the section via a data-attribute

    if (this.dataset.showAgeVerification) {
      this.verifyAge();
    }
  }

  /**
   * Shows the age verification modal if the user has not already verified their age.
   * @returns {Promise <boolean>}
   */
  async verifyAge() {
    if (this.ageIsVerified) return true;
    const ageIsVerifiedByModal = await this.showAgeVerificationModal();
    if (ageIsVerifiedByModal) {
      const event = new CustomEvent('pxl:ageVerificationSuccessful', {
        bubbles: true
      });
      this.dispatchEvent(event);
      return true;
    } else {
      this.showUnderAgeMessageAndRedirect();
      return false;
    }
  }

  /**
   * Shows the age verification modal.
   * @returns {Promise <boolean>}
   */
  async showAgeVerificationModal() {
    this.AgeVerificationModal.inert = true; // prevent the first focusable element (the i'm over 20 button) from being focused
    this.AgeVerificationModal.showModal();
    this.AgeVerificationModal.inert = false;

    return this.addButtonListenersAndResolvePromise();
  }

  /**
   * Adds button listeners to the age verification modal and, returns a promise resolved as true/false when the user clicks a button.
   * This enables us to e.g. await the result of the modal before adding products to cart.
   * @returns {Promise <boolean>}
   */
  addButtonListenersAndResolvePromise() {
    return new Promise(resolve => {
      this.ofAgeButton.addEventListener('click', () => {
        localStorage.setItem(this.storageKeyName, true);
        this.ageIsVerified = true;
        this.AgeVerificationModal.close();
        resolve(true);
      });

      // if the user presses escape to close the verification modal, assume under age
      this.AgeVerificationModal.addEventListener('cancel', () => {
        resolve(false);
      });

      this.underAgeButton.addEventListener('click', () => {
        resolve(false);
      });
    });
  }

  /**
   * Shows the under age message and redirects to homepage.
   * @returns {void}
   */
  showUnderAgeMessageAndRedirect() {
    this.customerIsUnderAge.showModal();

    setTimeout(() => {
      globalThis.location.href = '/';
    }, 5000);
  }
}

customElements.get('age-verification') ||
  customElements.define('age-verification', AgeVerification);
